<!--AI功能模块（左侧菜单 + iframe）-->
<template>
    <div class="ai-module">
        <!--左侧菜单-->
        <div class="menu-panel" v-if="showMenu">
            <div class="menu-scroll">
                <template v-for="(g, gi) in config.groups">
                    <div class="group-title" v-if="g.title" :key="'t'+gi">{{ g.title }}</div>
                    <div v-for="(it, ii) in g.items" :key="it.label"
                         :class="currentIndex === flatIndex(gi, ii) ? 'menu-btn menu-active' : 'menu-btn'"
                         @click="changeIndex(flatIndex(gi, ii))">
                        {{ it.label }}
                    </div>
                </template>
            </div>
        </div>
        <!--右侧iframe-->
        <div class="frame-panel">
            <iframe class="iframe-inner" :src="targetUrl" frameborder="0"></iframe>
        </div>
    </div>
</template>

<script>
/*AI模块链接基础地址*/
const AI_BASE_URL = 'https://jingzhunjy.com';
/*模块配置（与 uniapp 页面一致）*/
const MODULES = {
    //AI教案
    jiaoan: {
        title: 'AI教案',
        groups: [
            { title: 'AI教学设计', items: [
                { label: '自定义教案设计', url: '/chat/teadesign/1.html?auth_code=' },
                { label: '同步教案设计', url: '/chat/teadesign/2.html?auth_code=' },
                { label: '跨学科PBL设计', url: '/chat/tool/3.html?auth_code=' },
                { label: '跨学科设计', url: '/chat/teadesign/4.html?auth_code=' },
            ]},
            { title: 'AI大单元设计', items: [
                { label: '自定义大单元设计', url: '/chat/unitdesign/1.html?auth_code=' },
                { label: '大单元教学设计', url: '/chat/unitdesign/2.html?auth_code=' },
            ]},
            { title: 'AI项目化学习', items: [
                { label: '学科项目化学习', url: '/chat/prolearn/1.html?auth_code=' },
                { label: '跨学科项目化学习', url: '/chat/prolearn/2.html?auth_code=' },
                { label: '自定义项目化学习', url: '/chat/prolearn/3.html?auth_code=' },
                { label: '评价量规', url: '/chat/tool/2.html?auth_code=' },
            ]},
        ]
    },
    //AI学案
    xuean: {
        title: 'AI学案',
        groups: [
            { title: 'AI导学案', items: [
                { label: '导学案', url: '/chat/teadesign/3.html?auth_code=' },
                { label: '大单元导学案', url: '/chat/unitdesign/4.html?auth_code=' },
            ]},
            { title: 'AI学历案', items: [
                { label: '学历案', url: '/chat/academic/1.html?auth_code=' },
                { label: '大单元学历案', url: '/chat/academic/2.html?auth_code=' },
                { label: '自定义课时学历案', url: '/chat/academic/3.html?auth_code=' },
                { label: '自定义大单元学历案', url: '/chat/academic/4.html?auth_code=' },
            ]},
        ]
    },
    //AI课件（uniapp 页面无菜单，仅单个iframe）
    kejian: {
        title: 'AI课件',
        groups: [
            { title: '', items: [
                { label: 'AI课件', url: '/chat/general/2.html?auth_code=' },
            ]},
        ]
    },
    //AI习题
    xiti: {
        title: 'AI习题',
        groups: [
            { title: '', items: [
                { label: '知识点出题', url: '/chat/homework/1.html?auth_code=' },
                { label: '单元出题', url: '/chat/homework/2.html?auth_code=' },
                { label: '课时出题', url: '/chat/homework/3.html?auth_code=' },
            ]},
        ]
    },
};

export default {
    name: "aiModule",
    props: {
        moduleKey: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            currentIndex: 0,
        };
    },
    computed: {
        config() {
            return MODULES[this.moduleKey] || { groups: [] };
        },
        urls() {
            const list = [];
            this.config.groups.forEach(g => g.items.forEach(it => list.push(it.url)));
            return list;
        },
        showMenu() {
            return this.urls.length > 1;
        },
        targetUrl() {
            console.log("地址："+AI_BASE_URL + this.urls[this.currentIndex] + this.$storage.get('token'))
            return AI_BASE_URL + this.urls[this.currentIndex] + this.$storage.get('token');
        },
    },
    watch: {
        moduleKey() {
            this.currentIndex = 0;
        },
    },
    methods: {
        flatIndex(gi, ii) {
            let idx = 0;
            for (let i = 0; i < gi; i++) {
                idx += this.config.groups[i].items.length;
            }
            return idx + ii;
        },
        changeIndex(index) {
            this.currentIndex = index;
        },
    },
};
</script>
<style scoped>
.ai-module{
    width: 100%;
    height: 100%;
    display: flex;
    gap: 20px;
}
/*左侧菜单*/
.menu-panel{
    width: 220px;
    flex-shrink: 0;
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
}
.menu-scroll{
    height: 100%;
    overflow-y: auto;
    padding: 16px;
    box-sizing: border-box;
    scrollbar-width: none;
}
.menu-scroll::-webkit-scrollbar{
    width: 0;
    display: none;
}
.group-title{
    font-size: 16px;
    font-weight: bold;
    color: #bd3124;
    margin: 18px 0 4px;
}
.group-title:first-child{
    margin-top: 0;
}
.menu-btn{
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 15px;
    color: #86a2b3;
    background: #fff;
    border: 1px solid #e3eef7;
    border-radius: 10px;
    margin-top: 10px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 8px;
    box-sizing: border-box;
}
.menu-btn:hover{
    border-color: #27bbff;
    color: #27bbff;
}
.menu-active,
.menu-active:hover{
    background: #27bbff;
    border-color: #27bbff;
    color: #fff;
}
/*右侧iframe*/
.frame-panel{
    flex: 1;
    min-width: 0;
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
}
.iframe-inner{
    width: 100%;
    height: 100%;
    display: block;
    border: none;
}
</style>
